import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import AfterpayTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/afterpay-tender';
import AliPayTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/alipay-tender';
import AuPayTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/au-pay-tender';
import CashAppTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/cash-app-tender';
import LocalCashTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/local-cash-tender';
import DBaraiTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/dbarai-tender';
import EbtCashTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/ebt-cash-tender';
import MerpayTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/merpay-tender';
import PaypayTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/paypay-tender';
import SnapTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/snap-tender';
import RakutenPayTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/rakuten-pay-tender';
import WechatPayTender from '@square/dashboard-data/models/squareup/beemo/api/v2/models/push-tenders/wechat-pay-tender';

/*
 * Heads up! Adding a new push tender type?
 * Be sure to add a new translation key at activity.transactions.details.pushTenders.<tenderKeyName>
 * This is used by:
 * dashboard/app/components/transactions/refund-destination.js,
 * dashboard/app/components/sq-transaction-tender.js,
 * @dashboard/transaction-detail/addon/components/transaction/tender.js
 */

const PushTender = ProtoBaseModel.extend({
  afterpayTender: attr(AfterpayTender),
  alipayTender: attr(AliPayTender),
  auPayTender: attr(AuPayTender),
  cashAppTender: attr(CashAppTender),
  localCashTender: attr(LocalCashTender),
  dBaraiTender: attr(DBaraiTender),
  ebtCashTender: attr(EbtCashTender),
  merpayTender: attr(MerpayTender),
  paypayTender: attr(PaypayTender),
  rakutenPayTender: attr(RakutenPayTender),
  snapTender: attr(SnapTender),
  wechatPayTender: attr(WechatPayTender)
});
export const PushTenderTypes = new Enum(Object.keys(new PushTender().getAllProperties()));
export default PushTender;